import React from "react";
import { BadgeCheck, ShieldCheck, Radar, ClipboardCheck, DoorOpen } from "lucide-react";
import { SectionHeader } from "./_shared";

export default function SolutionPillars() {
  const pillars = [
    { icon: BadgeCheck, title: "Startup Passport", body: "A living verified capital profile containing company data, founders, business model, funding ask, documents, financial confidence labels, readiness scores, red flags, and investor-approved information." },
    { icon: ShieldCheck, title: "VENTURAZ Trust Score", body: "A proprietary readiness score based on company verification, filing hygiene, financial confidence, documentation, founder credibility, funding readiness, debt readiness, investor fit, and red flags.", anchorId: "trust-score" },
    { icon: Radar, title: "Investor Mandate Fit", body: "Investors discover opportunities aligned with their sector, stage, ticket size, geography, funding type, risk appetite, and preferred financial profile." },
    { icon: ClipboardCheck, title: "Diligence Reports", body: "Basic Health Check and Detailed Due Diligence Reports help convert raw startup information into structured investor-ready summaries." },
    { icon: DoorOpen, title: "Secure Deal Rooms", body: "Serious investor interest moves into controlled deal rooms with approved documents, reports, queries, responses, notes, and next actions." },
  ];
  return (
    <section id="solution-pillars" className="py-16 lg:py-20" data-testid="solution-pillars-section"
              style={{ background: "linear-gradient(180deg, #f6f4ef 0%, #ebe6db 100%)" }}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          eyebrow="THE PLATFORM"
          title="A verified capital-access layer for private companies."
          subtitle="VENTURAZ converts startup profiles into structured, diligence-backed capital profiles investors can evaluate with greater context."
        />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {pillars.map((p, i) => (
            <div
              key={p.title}
              id={p.anchorId}
              className="group rounded-lg border border-navy/10 bg-white p-6 hover:-translate-y-0.5 hover:border-gold hover:shadow-xl transition-all"
              data-testid={`pillar-card-${i + 1}`}
            >
              <div className="flex items-center gap-2 mb-3">
                <div className="w-9 h-9 rounded-md bg-navy text-cream flex items-center justify-center group-hover:bg-gold group-hover:text-navy transition-colors">
                  <p.icon size={16} />
                </div>
                <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-gold">PILLAR {i + 1}</div>
              </div>
              <div className="font-heading text-xl text-ink">{p.title}</div>
              <p className="mt-2 text-sm text-ink-soft leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
